const moment = require('moment');

export class DateTimeParser {

    public static dateOffsetParser = (dateTime: string | Date) => {

        let utcOffset = moment.parseZone(dateTime).utcOffset();

        if (utcOffset === 0) {
            return moment(dateTime).utc();
        }
       
        return moment(dateTime);
    }
}